import { Outlet, useParams } from "react-router-dom";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { isLocale } from "../../lib/routes";
import { Header } from "./Header";
import { Footer } from "./Footer";

export function AppLayout() {
  const { locale } = useParams();
  const { i18n } = useTranslation();
  const activeLocale = isLocale(locale) ? locale : "en";

  useEffect(() => {
    i18n.changeLanguage(activeLocale);
    document.documentElement.lang = activeLocale;
    document.documentElement.dir = activeLocale === "he" ? "rtl" : "ltr";
  }, [activeLocale, i18n]);

  return (
    <>
      <a className="skip-link" href="#main">Skip to content</a>
      <Header />
      <main id="main">
        <Outlet />
      </main>
      <Footer />
    </>
  );
}
